import './dom.css';

/*******************************************************************************
 * @ngdoc  component
 * @module csm.books.dom
 * @name   csm.books.dom.component:amountFieldGroup
 * @param  {Number}  model      Amount model.
 * @param  {String}  symbol     Currency symbol.
 * @param  {Boolean} allowInput `true` == allow input.
 * @description
 * Amount field input group. Includes a label and input field in a div. Input is
 * formatted as currency.
 *******************************************************************************/
export const amountFieldGroupComponent = {
  bindings: { model: '=ngModel', allowInput: '=', symbol: '@' },
  require: { ngModel: '' },
  transclude: true,
  template:
    '<label class="control-label" ng-transclude></label>' +
    '<input type="text" class="form-control" ' +
    'ng-model="$ctrl.model" ' +
    'ng-change="$ctrl.ngModel.$setViewValue($ctrl.model)" ' +
    'currency-input="{{$ctrl.symbol}}" ' +
    'ng-disabled="!$ctrl.allowInput"/>'
};
